import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=8008eff0&scoped=true"
import script from "./listItem.vue?vue&type=script&lang=js"
export * from "./listItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8008eff0",
  null
  
)

export default component.exports